module.exports = __webpack_public_path__ + "img/787165_DAD9CD_9DC0CE_36302A-256px.f5ed62e8.png";